import React, { Component } from 'react';



export default class ImgWithSrcset extends Component {

    constructor() {
        super();
        this.state = {
            error: false
        };
    }
    componentWillReceiveProps(nextProps) {
        // reset the error flag if we get a new src
        if (nextProps.src !== this.props.src)
            this.setState({ error: false });
    }

    getSrcSet(src, ignoreAltSrc) {

        var splitSrc = src.split(".");

        var extension = splitSrc.pop();

        // only do this for images on AWS
        if (src.indexOf("amazonaws") === -1) {
            return "";
        }

        // if we've errored, it's probably because of missing images on S3, so remove the srcset
        if (this.state.error) {
            return "";
        }

        if(ignoreAltSrc){
            return "";
        }

        var url = splitSrc.join(".");

        var srcsetBreakpoints = ['300w', '768w', '800w', '960w'];

        var srcset = [];

        for (var i = 0; i < 4; i++) {
            srcset.push(`${url}_x${i + 1}.${extension} ${srcsetBreakpoints[i]}`);
        }

        return srcset.join(",");
    }

    render() {

        var { src, alt, onError = () => { }, ignoreAltSrc, ...otherProps } = this.props;

        var srcset = this.getSrcSet(src, ignoreAltSrc);

        var onLoadingError = () => {
            // if we're still erroring after setting the error flag, propagate the error
            if (this.state.error)
                onError();
            else
                this.setState({ error: true });
        }


        return (<img src={src} srcSet={srcset} alt={alt} {...otherProps} onError={onLoadingError} />);
    }
}


// WEBPACK FOOTER //
// ./src/components/ImgWithSrcset.js